import React, { useEffect, useState } from "react";
import { Badge, Table } from "react-bootstrap";
import SplitPane from "react-split-pane";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const codeTextStyle = {
  display: "block",
  margin: 0,
  padding: "6px 8px",
  fontFamily: "Consolas, Monaco, 'Courier New', monospace",
  fontSize: 12,
  lineHeight: 1.45,
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  overflowWrap: "anywhere",
  backgroundColor: "#f4f6f8",
  border: "1px solid #e3e7eb",
  borderRadius: 4,
  maxWidth: 420,
};

const CodeText = ({ value }) => (
  <code style={codeTextStyle} title={value || ""}>
    {value || "-"}
  </code>
);

const TestCases = ({ checkData, refreshKey = 0 }) => {
  const { studyId } = useParams();
  const [testCases, setTestCases] = useState([]);
  const [loading, setLoading] = useState(false);

  const getTestCases = async () => {
    if (!studyId || !checkData?.checkId) {
      setTestCases([]);
      return;
    }
    setLoading(true);
    const data =
      await studyLevelFormManagementServices.getStudyLevelCustomEditCheckTestCase(
        studyId,
        checkData.checkId
      );
    setTestCases(data?.data || []);
    setLoading(false);
  };

  useEffect(() => {
    getTestCases();
  }, [studyId, checkData?.checkId, refreshKey]);

  return (
    <SplitPane
      split="vertical"
      minSize={"100%"}
      style={{ height: "-webkit-fill-available" }}
    >
      {loading ? (
        <PageLoader />
      ) : testCases.length === 0 ? (
        <NoDataFoundTable MSG="No test case history found." />
      ) : (
        <Table className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th style={{ width: 50 }}>Sr.</th>
              <th>Query</th>
              <th>Query Value</th>
              <th style={{ width: 90 }}>Output</th>
              <th style={{ width: 90 }}>Status</th>
              <th style={{ width: 160 }}>Run At</th>
            </tr>
          </thead>
          <tbody>
            {testCases.map((item, index) => (
              <tr key={item._id || index}>
                <td>{index + 1}</td>
                <td>
                  <CodeText value={item?.query} />
                </td>
                <td>
                  <CodeText value={item?.queryValue} />
                </td>
                <td>{item?.output}</td>
                <td>
                  {item?.status === "VALID" || item?.status === "INVALID" ? (
                    <Badge bg={item?.status === "VALID" ? "success" : "danger"}>
                      {item?.output}
                    </Badge>
                  ) : (
                    <Badge bg={item?.status === "PASS" ? "success" : "danger"}>
                      {item?.status}
                    </Badge>
                  )}
                </td>
                <td>
                  {item?.createdAt
                    ? new Date(item.createdAt).toLocaleString()
                    : "-"}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </SplitPane>
  );
};

export default TestCases;
